import { useMemo } from "react";

import { getTimeLocal } from "../services/date";

const convertUTCTimeToLocal = (template) => ({
  ...template,
  time: getTimeLocal(template?.time),
});

const useTemplate = () => {

  const params = useMemo(() =>
    new URLSearchParams(window.location.search),
  [window.location.search]);

  let param = params.get("template");
  
  if (param) {
    try {
      param = decodeURIComponent(param);
    } catch (err) {
      console.log("Loading template without URL decoding..");
    }

    const template = JSON.parse(param);
    
    if (template.frequency) {
      template.frequency = template.frequency.toString();
      console.log("Parsing frequency as string: ", template.frequency);
    }
    
    console.log("Loading template: ", template);
    
    return convertUTCTimeToLocal(template);
  }

  return null;
}

export default useTemplate;
